/* 
let kitchenData = [
    {
        "name": "Kitchen V1",
        "config": "05050907020C000015",
        "isDesigner": false,
        "date": 1524379940
    },
        {
        "name": "Kitchen V2",
        "config": "05050907020C000015",
        "isDesigner": true,
        "date": 1524379940
    },
        {
        "name": "Bob's Kitchen",
        "config": "05050907020C000015",
        "isDesigner": false,
        "date": 1524379940
    }
];
*/

let currentKitchenIndex = -1;
let viewer = document.querySelector('onfigr');
let nameActionApplied = false;
let hasOnlyOpenedOnce = true;

const startTracking = (pageType) => {
    console.log(`start tracking ${pageType}`);
    pageType = pageType || "(not set)";
    dataLayerPush({'pageType': pageType});
}

const dataLayerPush = (trackObj) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(trackObj);
};

const postData = async function(opportunityId, payload) {
    console.log("postData");
    console.log(opportunityId, payload);
    const postURL = "/kv/save/" + opportunityId;
    //console.log(postURL);
    const response = await fetch(postURL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),

    });
    const data = await response.json();
    console.log(data);
    return data;
}

const postThenLoadData = async function(opportunityId, payload) {
    console.log("postThenLoadData");
    console.log(opportunityId, payload);
    const postURL = "/kv/save/" + opportunityId;
    //console.log(postURL);
    const response = await fetch(postURL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),

    });
    const data = await response.json();
    console.log(data);
    loadData();
    return data;
}

const saveKitchen = function() {
    console.log('saveKitchen');
    const configurationString = viewer.getAttribute('config');
    const summary = viewer.getActiveElements();
    //console.log(summary);
        /* console.log(configurationString);
    console.log(opportunityId); */

    let kitchenName = document.getElementsByClassName("menu-panel__heading")[0].innerText;

    if (currentKitchenIndex == -1) {
        kitchenData.push({
            //"name": "New Kitchen " + parseInt(kitchenData.length + 1),
            "name": kitchenName,
            "config": configurationString,
            "isDesigner": false,
            "date": Date.now(),
            "summary": summary
        });
        currentKitchenIndex = kitchenData.length - 1;
    } else {
        kitchenData[currentKitchenIndex].name = kitchenName;
        kitchenData[currentKitchenIndex].config = configurationString;
        kitchenData[currentKitchenIndex].summary = summary;
        kitchenData[currentKitchenIndex].date = Date.now();
    } 

    let success = postData(opportunityId, kitchenData);
    console.log(`save success: ${success}`);
    popAlert("saved");
}

const popAlert = function(which) {
    let alert = document.getElementById("alert");
    alert.classList.add("active");
    setTimeout(function() {
        alert.classList.remove("active");
    }, 2000);
}


const applyKVButtonActions = function() {
    let kitchenButtons = document.getElementsByClassName("js-kvbutton");
    //loop over kitchenButtons and add event listener
    for (i=0; i<kitchenButtons.length; i++) {
        kitchenButtons[i].addEventListener("click", function(evt) {
            let kvInit = evt.currentTarget.value;
            let isCollection = evt.currentTarget.classList.contains("js-collections")
            console.log(kvInit, isCollection);
            showKV(kvInit, isCollection);
        });
    }
}

const vkinit = function() {
    // Start GA Tracking and Add Region to dataLayer
    startTracking("web visualizer home page");
    dataLayerPush({"region": "PA"});    

    viewer.addEventListener('onfigr-save', e => {
        console.log('Save button clicked.');
        saveKitchen();
    });

    viewer.addEventListener('onfigr-close', e => {
        //console.log('Close button clicked.');
        hideKV();
        loadData();
    });

    viewer.addEventListener('scene-data-loaded', e => {
        if (selectedCollection) {
            const vkBody = document.getElementById("kitchen_visualizer");
            vkBody.classList.add("active");
            console.log("loading from post");
            setTimeout(function() {
                //have to wait a second to do this (to allow the scene to load)
                applyNameChangeAction();
            }, 1000);
        }
    });
   

    applyKVButtonActions();
    deleteButtonEvents();

    let showCollectionsButton = document.getElementById("showCollections");
    showCollectionsButton.addEventListener("click", function() {
        let which = document.getElementById("collections-container").classList.toggle("open");
        document.getElementById("arrowHolder").classList.toggle("open");
        console.log(which);
        if (which) {
            showCollectionsButton.innerText = "Hide All Collections";
        } else {
            showCollectionsButton.innerText = "View All Collections";
        }
    });
}


const showKV = function(kvIndex, isCollection) {
    const vkBody = document.getElementById("kitchen_visualizer");

    //console.log(kvIndex);
    currentKitchenIndex = kvIndex;
    if (kvIndex != -1 && !isCollection) {
        let currentKitchen = kitchenData[kvIndex];
        //console.log(currentKitchen);
        viewer.setConfiguration(currentKitchen.config);
        //viewer.setAttribute('config', currentKitchen.config);

        setTimeout(function() {
            viewer.api.setRoomName(titleCase(currentKitchen.name));
        }, 100); //Can't fire right away... for reasons
        //document.getElementsByClassName("menu-panel__heading")[0].innerText = currentKitchen.name;
    } else if (kvIndex != -1 && isCollection) {
        console.log("NEW COLLECTION KTICHEN - find it in the collection data");
        let currentKitchen = collectionsData[kvIndex];
        viewer.setConfiguration(currentKitchen.config);
        viewer.api.setRoomName(titleCase(currentKitchen.name + "*"));
        currentKitchenIndex = -1;
    } else {
        let newKitchenName = "New Kitchen " + parseInt(kitchenData.length + 1);
        viewer.setConfiguration("00O00001W0370XH03700600J00J0370XH000000"); //default scene
        viewer.api.setRoomName(titleCase(newKitchenName));
    }

    vkBody.classList.add("active");
    
    applyNameChangeAction();

    // Adding Tracking Class to Stacked Cabinet Slider
    document.getElementsByClassName("menu-bar__option")[0].addEventListener('click', e => {
        if (!document.getElementsByClassName("switch-box")[1].classList.contains("tracking_stackedCabinets")) {
            document.getElementsByClassName("switch-box")[1].classList.add("tracking_stackedCabinets");
        }
    });
}

const applyNameChangeAction = function() {
    if (!nameActionApplied) {
        const kvTitle = document.getElementsByClassName("menu-panel__heading");
        kvTitle[0].addEventListener("click", function() {
            askToChangeTitle()
        })
        nameActionApplied = true;
    }
}

const hideKV = function() {
    const response = confirm("Have you saved your changes? Do you want to close the Kitchen Visualizer?");
    if (response == true) {
        const vkBody = document.getElementById("kitchen_visualizer");
        vkBody.classList.remove("active");
    }
}


const askToChangeTitle = function() {
    const kvTitle = document.querySelector(".menu-panel__heading");
    let currentTitle = kvTitle.textContent;
    currentTitle = titleCase(currentTitle);
    //console.log(kvTitle.textContent);
    let newTitle = prompt("Rename Kitchen", currentTitle);

    if (newTitle != null && newTitle != "") {
        //kitchenData[currentKitchenIndex].name = newTitle;
        //console.log(kitchenData[currentKitchenIndex]);
        viewer.api.setRoomName(titleCase(newTitle));
        console.log(newTitle)
        saveKitchen();
    }
}

// Get Data Function
async function getData(opportunityId) {
    let response = await fetch(
        "/kv/get/" + opportunityId + ".json",
        {
            method: 'GET',
            cache: 'no-cache'
        }
    );
    let data = await response.json();
    return data;
}

const titleCase = (str) => {
    console.log(str)
    str = str.toLowerCase().split(" ");
    for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
    }
    console.log(str)
    return str.join(" ");
}

const loadData = async function() {
    saveData = await getData(opportunityId);
    for (let i = 0; i < saveData.length; i++) {
        saveData[i].name = titleCase(saveData[i].name);
    }
    let saves = document.getElementById("saved-collections");
    let newButtonClone = document.getElementsByClassName("new-scene")[0].cloneNode(true);
    saves.innerHTML = "";

    // Create Buttons and Add to DOM
    for (let i = 0; i < saveData.length; i++) {    
        console.log(saveData);

        let kvButtonParent = document.createElement('div');
        kvButtonParent.classList.add("kv-button-holder");
        
        let deleteButtonSection = document.createElement('section');
        let deleteButton = document.createElement('div');
        deleteButton.classList.add('trash-can');
        deleteButton.value = i;

        let kvButton = document.createElement('button');
        kvButton.classList.add("js-kvbutton");
        kvButton.classList.add("kvbutton");
        kvButton.classList.add('tracking_savedScene');
        kvButton.value = i;

        let imageHolder = document.createElement('div');
        imageHolder.classList.add("img_holder");
        let image = document.createElement('img');
        image.setAttribute("src", saveData[i].summary.previewImage);
        image.setAttribute("alt" ,saveData[i].name);

        let kitchenName = document.createElement('h4');
        kitchenName.innerText = saveData[i].name.toLowerCase();
        let personalizeDiv = document.createElement("p");
        personalizeDiv.innerText = "Personalize This Scene";

        imageHolder.appendChild(image);
        kvButton.appendChild(imageHolder);
        kvButton.appendChild(kitchenName);
        kvButton.appendChild(personalizeDiv);
        deleteButtonSection.appendChild(deleteButton);
        kvButtonParent.appendChild(deleteButtonSection);
        kvButtonParent.appendChild(kvButton);
        saves.appendChild(kvButtonParent);
    }

    saves.appendChild(newButtonClone);
    applyKVButtonActions();
    deleteButtonEvents();
}

const deleteButtonEvents = () => {
    let deleteButtons = document.getElementsByClassName('trash-can');
    for (let i = 0; i < deleteButtons.length; i++) {
        deleteButtons[i].addEventListener("click", function(evt) {
            const response = confirm(`Are you sure you want to delete ${kitchenData[i].name}?`);
            if (response === true) {
                let newData = [];
                for (let j = 0; j < kitchenData.length; j++) {
                    if (j !== i) {
                        newData.push(kitchenData[j]);
                    }
                }
                let success = postThenLoadData(opportunityId, newData);
                console.log("CLICK CLICK CLICK " + deleteButtons[i].value)
            }
        })
        
    }
}


const isVWpage = document.body.classList.contains('visualizer');

if (isVWpage) {
    console.log("kv initializing");
    vkinit();
}

